module.exports = __webpack_public_path__ + "static/media/old_computer.1fba1af5.jpg";